import { useState, useCallback } from 'react';
import { get } from '@atlassian/jira-common-rest/src/simplified/latest/project/validate/project-key';
import { fireErrorAnalytics } from '@atlassian/jira-errors-handling';
import { APP_TEAM_NAME } from '@atlassian/jira-project-create-importer-common';
import { APP_IDENTIFIER } from '../../common/constants';
import type { UseValidateProjectKey } from './types';

export const useValidateProjectKey = (): UseValidateProjectKey => {
	const [isLoading, setIsLoading] = useState(false);
	const [hasErrorOccurred, setHasErrorOccurred] = useState(false);

	const validateProjectKey = useCallback(async (projectKey: string) => {
		setIsLoading(true);
		setHasErrorOccurred(false);

		try {
			const { errors } = await get('', projectKey);
			setIsLoading(false);
			return errors?.projectKey;
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			fireErrorAnalytics({
				meta: {
					id: 'project-key-validation-error',
					packageName: APP_IDENTIFIER,
					teamName: APP_TEAM_NAME,
				},
				sendToPrivacyUnsafeSplunk: true,
				error,
			});

			setHasErrorOccurred(true);
			setIsLoading(false);
			return null;
		}
	}, []);

	return { isLoading, hasErrorOccurred, validateProjectKey };
};
